module.exports = "  gl_FragColor = linearToOutputTexel( gl_FragColor );\n"